import { TenantSubdomain } from "features/types";

const sponsoredTenants: TenantSubdomain[] = [];

export default sponsoredTenants;
